import React from 'react';

export default function MapDefaultAttribution() {
  return (
    <small style={{ background: '#fff', color: '#333', fontSize: 10 }}>
      <a href="/credits">Data credits</a>
    </small>
  );
}
